/**
 * Всплывашки на сайте
 *
 * NOTE: Механизм, позволяющий отменить скролл для страницы, при открытой всплывашке,
 * достаточно хитрый, поэтому лучше изучить данный модуль, чтобы досконально понимать, как он работает
 */
itsoftApp.createModule("popups", function() {
    const module = this;
    module.$wrapper = document.querySelector(".l-wrapper");
    const popups = document.querySelectorAll("." + "popup"); // this.popupClass

    if (!popups.length) { // TODO: Убрать или переделать, чтобы тесты прошли
        return false;
    }

    // Локальные переменные
    const $body = document.body;
    const $document = document.documentElement;
    // const activePopups = document.querySelectorAll("[data-bg-opened='true']");
    // const popupBox = document.querySelector("#popup-box");
    const fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
    const hasFixedElems = fixedPageElems.length > 0;
    const staticBackUrl = window.location.pathname;
    const dAttrAutohide = "data-autohide";
    const transitionEventEnd = itsoftApp.features.transitionEventEnd;
    // const disabledButtons = document.querySelectorAll(".js-disabled");
    const confirmation = document.querySelector(".js-confirmation");
    // const save = document.querySelector(".js-save");
    // const slider = {};
    // const hashedPopups = document.querySelectorAll("data-hash");
    window.currentOpenedPopup = undefined;
    const getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
    const getScrTop = itsoftApp.utils.getScrTop;

    let currentSlide;
    let activeButton;
    // let pageHash;

    // if (hashedPopups.length > 0) {
    //     pageHash = location.hash;
    // }

    const Breakpoint = {
        mobile: 320,
        tablet: 768,
        desktop: 1280
    };

    const Popup = function (popup) {
        if (!popup) {
            try {
                throw new Error("Не передан обязательный аргумент popup");
            } catch (err) {
                console.log(err);
            }
        }

        this.state = {
            closeButtonsAvailability: false,
            openButtonsAvailability: false,
            initedExemplar: false,
            opened: false
        };

        this.popup = popup;
        this.popupID = popup.id;
        this.openPopupBtnSelector = ".js-open-popup[data-popup-id='" + popup.id + "']";
        this.closePopupBtnSelector = ".js-close-popup[data-popup-id='" + popup.id + "']";
        this.openPopupBtns = document.querySelectorAll(this.openPopupBtnSelector);
        this.closePopupBtns = document.querySelectorAll(this.closePopupBtnSelector);
        this.popupClass = "popup";
        this.openedClass = "is-opened";
        this.dAttrSelector = "data-popup-selector";
        this.dAttrBgClose = "data-bg-close";
        this.hiddenClass = "g-hidden";
        this.evNameOpen = "popups:open";
        this.evNameClose = "popups:close";
        this.wrapperAbsClass = "is-abs";
        this.wrapperOverflow = "is-over";
        this.popupOpenedClass = "is-popup-opened";
        this.dAttrUrl = "data-url";
        this.dAttrHide = "data-hide";
        this.dAttrClose = "data-close-popup";
        this.hideDelayDefault = 3500;

        this.init();
    };

    Popup.prototype.globalState = {
        listenersAdded: false,
        historyPushed: false,
    };

    Popup.prototype.openedPopups = [];
    Popup.prototype.autohidePopups = [].filter.call(popups, function (el) {
        return el.matches("[" + dAttrAutohide + "='true']");
    });

    Popup.prototype.lastOpenedPopup = null;

    Popup.prototype.detachEvents = function () {
        this.popup.removeEventListener(this.evNameOpen, this.popupOpen);
        this.popup.removeEventListener(this.evNameClose, this.popupClose);
        this.popup.removeEventListener("click", this.popupClick);

        Array.prototype.forEach.call(this.openPopupBtns, function (openBtn) {
            openBtn.removeEventListener("click", this.openPopupBtnClick);
        });

        Array.prototype.forEach.call(this.closePopupBtns, function (closeBtn) {
            closeBtn.removeEventListener("click", this.closePopupBtnClick);
        });
    };

    Popup.prototype.init = function () {
        const POPUP = this;

        /**
         * Обработчик нажатий на кнопки клавиатуры.
         * Необходим для того, чтобы можно было закрыть всплывашку кнопкой ESC.
         *
         * NOTE: Так как возможны случаи, когда открыто несколько всплывах,
         * то закрываем их одна за одной, начиная с той, у которой наибольший z-index.
         *
         * @param  {object} e Event
         */
        Popup.prototype.keyController = function (evt) {
            // Обрабатываем только нажатие на ESC,
            // а все остальные нажатия игнорируем.
            if (evt.keyCode !== 27) {
                return;
            }

            if (!POPUP.openedPopups.length) {
                return;
            }

            let maxZI = 0;

            Array.prototype.forEach.call(POPUP.openedPopups, function (el) {
                const popup = el;
                let zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

                if (isNaN(zi)) {
                    zi = 0;
                }
                if (zi >= maxZI) {
                    maxZI = zi;
                    POPUP.lastOpenedPopup = popup;
                }
            });

            if (!POPUP.lastOpenedPopup) {
                return;
            }

            // Закрываем только последнюю открытую всплывашку
            if (!POPUP.lastOpenedPopup.hasAttribute("data-save")) {
                POPUP.lastOpenedPopup.dispatchEvent(window.closeEvent);
            }
        };


        if (!this.globalState.listenersAdded) {
            if (window.CustomEvent && typeof window.CustomEvent === "function") {
                window.closeEvent = new CustomEvent(this.evNameClose, {detail: {name: "Закрытие"}});
                window.openEvent = new CustomEvent(this.evNameOpen, {detail: {name: "Открытие"}});
            } else {
                window.closeEvent = document.createEvent("CustomEvent");
                window.openEvent = document.createEvent("CustomEvent");
                window.closeEvent.initCustomEvent(this.evNameClose, true, true, {name: "Закрытие"});
                window.openEvent.initCustomEvent(this.evNameOpen, true, true, {name: "Открытие"});
            }

            window.addEventListener("beforeunload", this.windowUnload);
            window.addEventListener("keyup", this.keyController);

            this.globalState.listenersAdded = true;
        }

        if (this.closePopupBtns.length > 0) {
            this.state.closeButtonsAvailability = true;
        }

        if (this.openPopupBtns.length > 0) {
            this.state.openButtonsAvailability = true;
        }

        /**
         * Клик по кнопкам, открывающим всплывахи.
         * Какую именно всплывашку открыть - обозначено в data- атрибуте.
         */
        Popup.prototype.openPopupBtnClick = function (evt) {
            evt.preventDefault();

            const self = this;
            const dataSlide = self.getAttribute("data-slide");
            // const selector = self.getAttribute(POPUP.dAttrSelector);

            dataSlide ? currentSlide = dataSlide : currentSlide = undefined;

            // if (selector) {
                // if (popup) {
            POPUP.popup.dispatchEvent(window.openEvent);
                // }
            // }

            // else {
            //     const popupType = self.getAttribute("data-popup-type")

            //     if (popupType = "image") {
            //         createImagePopup(self);
            //     } else {
            //         return;
            //     }
            // }
        };


        /**
         * Клик по кнопкам, закрывающим всплывашку.
         * Будет закрыта "родительская" всплывашка
         * (поиск по ближайшему родителю с нужным классом).
         */
        Popup.prototype.closePopupBtnClick = function () {
            const self = this;
            let checkbox = null;
            // const popup = self.closest("." + popupClass);
            const onBoxCheck = function (evt) {
                if (evt.currentTarget.classList.contains("js-error")) {
                    checkbox.classList.remove("js-error");
                    checkbox.removeEventListener("change", onBoxCheck);
                }
            };

            if (this.classList.contains("js-save")) {
                if (self.hasAttribute("data-checkbox")) {
                    const checkboxID = self.getAttribute("data-checkbox");
                    checkbox = confirmation.querySelector(checkboxID);

                    if (!checkbox.checked) {
                        checkbox.classList.add("js-error");
                        checkbox.addEventListener("change", onBoxCheck);
                        return;
                    }
                }

                itsoftApp.modules.cookie.setCookie(this);
            }

            POPUP.popup.dispatchEvent(window.closeEvent);
        };

        /**
         * Все действия, связанные с открытием всплывашки
         */
        Popup.prototype.popupOpen = function () {
            const self = this;

            if (self.classList.contains(POPUP.openedClass)) {
                return;
            }

            // Если до этого уже были открыты всплывашки,
            // то вычисляем наибольший z-index, и присваиваем его
            // новой открывающейся всплывашке.
            // Иначе возможны ситуации, когда всплывашка открылась, но из-за расположения по вёрстке
            // оказалась ниже (за счет одинакового z-index), и в итоге её не видно.

            if (POPUP.openedPopups.length > 0) {
                let maxZI = 0;

                Array.prototype.forEach.call(POPUP.openedPopups, function (el) {
                    const popup = el;

                    if (popup.getAttribute("data-ignore") === "true") {
                        return;
                    }

                    let zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

                    if (isNaN(zi)) {
                        zi = 0;
                    }

                    maxZI = Math.max(maxZI, zi);
                });

                if (maxZI > 0) {
                    self.style.zIndex = maxZI + 1;
                    DEBUG && console.log("%c--[module popups] added z-index " + (maxZI + 1) + ", because there was another opened popups", "font-style: italic; color: #999");
                }
            }

            // Вычисляем текущую величину прокрутки страницы
            // (делаем это до того, как будут произведены какие-либо дальнейшие действия).
            let scrTop = getScrTop();
            DEBUG && console.log("[module popups] scrTop: " + scrTop);

            // Если есть fixed элементы на странице,
            // то задаём им padding-right, равный ширине полосы прокрутки.
            // Без этого такие элементы будут дёргаться,
            // так как в процессе открытия всплывашки слегка меняются общие стили страницы.
            if (hasFixedElems) {
                let scrollbarWidth = getScrollbarWidth();
                DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);

                Array.prototype.forEach.call(fixedPageElems, function (el) {
                    el.style.paddingRight = scrollbarWidth + "px";
                });
            }

            // NOTE: Это из-за плашки browser-update,
            // которая задаёт <html> ненулевой margin-top,
            // (в случае, если плашка об устаревшем браузере показана)
            // из-за которого страница "прыгает".
            const mt = parseInt(getComputedStyle($document)["marginTop"], 10);
            const mtExists = !isNaN(mt) && mt !== 0;
            if (mtExists) {
                scrTop -= mt;
            }

            // Основная магия происходит здесь.
            // Элементу .l-wrapper задаётся класс, который одновременно
            // убирает полосу прокрутки у <body> (так как .l-wrapper теперь position: absolute),
            // и добавляет полосу прокрутки у самого .l-wrapper (за счёт overflow: auto).
            // После этого остаётся прокрутить элемент .l-wrapper до того же значения,
            // которое было до этого у <body> (мы посчитали эту величину ранее).
            // Происходит это достаточно быстро, чтобы пользователь ничего не заметил.
            if (module.$wrapper) {
                module.$wrapper.classList.add(POPUP.wrapperAbsClass);
                module.$wrapper.scrollTop = scrTop;
            }

            // NOTE: Это из-за плашки browser-update
            if (mtExists) {
                $document.scrollTop = 0;
            }

            // Это для отсутсвия скролла у <body> в некоторых редких случаях
            // (например, если висит плашка об устаревшем браузере)
            if (!POPUP.popup.hasAttribute("data-scroll")) {
                $body.classList.add(POPUP.popupOpenedClass);
            }

            // Здесь предусмотрена возможность автоматически скрывать некоторые всплывашки
            // при открытии других всплывашек.
            // Для этого им нужно задать определённый data- атрибут
            // (указан в локальных переменных в начале модуля).
            let autohidePopupsOpened = [].filter.call(POPUP.autohidePopups, function (el) {
                return el.classList.contains(POPUP.openedClass);
            });

            if (autohidePopupsOpened.length > 0) {
                DEBUG && console.log("[module popups] hided " + autohidePopupsOpened.length + " popups with " + dAttrAutohide + "=true");
                Array.prototype.forEach.call(autohidePopupsOpened, function (el) {
                    el.classList.remove(POPUP.openedClass);
                });
            }

            if (window.currentOpenedPopup) {
                window.currentOpenedPopup = undefined;
            }

            // Далее, делаем нашу всплывашку видимой (за счёт класса)
            self.classList.add(POPUP.openedClass);
            window.currentOpenedPopup = self;
            POPUP.openedPopups.push(self);
            POPUP.state.opened = true;

            const videoItem = self.querySelector(".js-video-item");

            if (videoItem) {
                itsoftApp.modules.video.videoPlay(videoItem);
            }


            let isIncludeSlider = self.hasAttribute("data-slider");

            if (isIncludeSlider) {
                if (self.getAttribute("data-slider") !== "true") {
                    const sliderContainer = self.closest(".js-slider");
                    self.setAttribute("data-slider", "true");
                    itsoftApp.modules.slidersLibrary.callback(sliderContainer, undefined, undefined, self.getAttribute("data-slider-name"), currentSlide);
                } else {
                    itsoftApp.modules.slidersLibrary.slider[self.getAttribute("data-slider-name")].slideTo(+currentSlide);
                }
            }

            if (self.hasAttribute("data-destroy-device")) {
                const onWindowResize = function () {
                    if (itsoftApp.utils.getViewportSize() >= Breakpoint[self.getAttribute("data-destroy-device")]) {
                        self.dispatchEvent(window.closeEvent);
                        window.removeEventListener("resize", onWindowResize);
                    }
                };

                window.addEventListener("resize", onWindowResize);
            }

            // Здесь предусмотрена возможность
            // закрыть текущую всплывашку через определённый промежуток времени
            // (например, всплывашка с коротким информационным сообщением).
            // Для этого им нужно задать определённый data- атрибут
            // (указан в локальных переменных в начале модуля).
            let hideDelay = self.getAttribute(POPUP.dAttrHide);
            if (hideDelay) {
                hideDelay = parseInt(hideDelay, 10);
                hideDelay = isNaN(hideDelay) ? POPUP.hideDelayDefault : hideDelay;
                setTimeout(function () {
                    self.dispatchEvent(window.closeEvent);
                }, hideDelay);
            }

            // При необходимости, можно управлять адресной строкой браузера
            const urlToChange = self.getAttribute(POPUP.dAttrUrl);
            if (urlToChange) {
                POPUP.changePageUrl(urlToChange);
            }

            DEBUG && console.log("[module popups] opened popup: " + (self.id ? "#" + self.id : "." + self.className));
        };

        /**
         * Все действия, связанные с закрытием всплывашки
         */
        Popup.prototype.popupClose = function () {
            const self = this;
            if (!POPUP.state.opened) {
                return;
            }

            if (activeButton) { /* ??? */
                activeButton.classList.remove("js-active");
                activeButton = undefined;
            } /* ??? */

            self.classList.remove(POPUP.openedClass);

            // Так как вплывашка прилетает не мгновенно, а плавно,
            // то сразу делать возврат страницы к исходному состоянию нельзя
            // (будут видны артефакты, сязанные с переводом полосы прокрутки
            // от body к .l-wrapper и обратно).
            const end = function () {
                const videoItem = self.querySelector(".js-video-item");

                if (videoItem) {
                    itsoftApp.modules.video.videoStop(videoItem);
                }
                setTimeout(function () {
                    POPUP.clearScrollStyles();
                }, 200);

                if (transitionEventEnd) {
                    self.removeEventListener(transitionEventEnd, end);
                    POPUP.openedPopups.pop();
                }

                POPUP.state.opened = false;
            };

            // Для современных браузеров, где работает свойство transition,
            // вешаем обработчик на событие transitionEnd.
            if (transitionEventEnd) {
                self.addEventListener(transitionEventEnd, end);

            // Для старых браузеров, сразу вызываем функцию.
            } else {
                end();
            }

            // При необходимости,
            // меняем (возвращаем обратно)
            // адрес в строке браузера.
            const urlToChange = self.getAttribute(POPUP.dAttrUrl);
            if (urlToChange) {
                POPUP.changePageUrl("back");
            }

            DEBUG && console.log("[module popups] closed popup: " + (self.id ? "#" + self.id : "." + self.className));
        };

        /**
         * Возврат страницы к исходному
         * (до того, как была открыта хоть одна всплывшка)
         * состоянию.
         *
         * @param  {boolean} force Часть функционала можно исполнить принудительно
         */
        Popup.prototype.clearScrollStyles = function (force) {
            if (force == null) {
                force = false;
            }

            // Функция выполнится, если не осталось открытых всплывашек
            // (потому что их может быть несколько, и закрытие одной не означает закрытие всех),
            // либо принудительно (в редких случаях).
            const hasOpenedPopups = POPUP.openedPopups.length > 0;
            if (hasOpenedPopups && !force) {
                return;
            }

            // Вычисляем текущую величину прокрутки страницы
            // (функция getScrTop достаточно "умная", чтобы посчитать текущий скролл при любом состоянии).
            // Это нужно сделать до того, как произойдут дальнейшие действия.
            // $wrapper.classList.add(wrapperOverflow);
            let scrTop = getScrTop();
            DEBUG && console.log("%c[module popups] (clearScrollStyles) scrTop: " + scrTop + ". force: " + force, "color: #999");
            // $wrapper.classList.remove(wrapperOverflow);
            // Возвращаем структурные элементы .l-wrapper и body
            // к исходному состоянию, убираем все необходимые классы.
            if (module.$wrapper) {
                module.$wrapper.classList.remove(POPUP.wrapperAbsClass);
            }

            $body.classList.remove(POPUP.popupOpenedClass);

            // Если на странице есть fixed элементы,
            // то убираем ранее заданное значение radding-right
            if (hasFixedElems) {
                Array.prototype.forEach.call(fixedPageElems, function (el) {
                    el.style.paddingRight = "";
                });
            }

            // NOTE: Это из-за плашки browser-update
            const mt = parseInt(getComputedStyle($document)["marginTop"], 10);
            const mtExists = !isNaN(mt) && mt !== 0;
            if (mtExists) {
                scrTop += mt;
            }

            // Наконец, пролистываем body до того значения,
            // который был у .l-wrapper.
            // Происходит это довольно быстро, так что пользователь не заметит разницы.
            $document.scrollTop = scrTop;
        };

        /**
         * Обработчик события "click", который определяет,
         * по какому именно мы кликнули элементу, и, если это
         * "пустое пространство" за самой всплывахой,
         * то закрываем её.
         *
         * NOTE: Можно отменить данное действие, задав дополнительный data- атрибут
         *
         * @param  {object} e Event
         */
        Popup.prototype.popupClick = function (evt) {
            const self = this;
            if (evt.target === self && self.getAttribute(POPUP.dAttrBgClose) !== "false") {
                self.dispatchEvent(window.closeEvent);
            }
        };

        /**
         * Так как прокрутку страницы мы "отменяем" хитрым способом,
         * то при попытке перезагрузить страницу, на которой уже открыта всплывашка,
         * нас перекинет наверх страницы.
         * Это подбешивает, поэтому привязываем данную функцию на событие закрытия (обновления)
         * страницы. Мы принудительно возвращаем страницу к её исходному состоянию,
         * тем самым нас не перекинет наверх после перезагрузки.
         */
        Popup.prototype.windowUnload = function () {
            POPUP.clearScrollStyles(true);
        };

        this.popup.addEventListener(POPUP.evNameOpen, POPUP.popupOpen);
        this.popup.addEventListener(POPUP.evNameClose, POPUP.popupClose);
        this.popup.addEventListener("click", POPUP.popupClick);

        Array.prototype.forEach.call(this.openPopupBtns, function (openBtn) {
            openBtn.addEventListener("click", POPUP.openPopupBtnClick);
        });

        Array.prototype.forEach.call(this.closePopupBtns, function (closeBtn) {
            closeBtn.addEventListener("click", POPUP.closePopupBtnClick);
        });

        if (this.popup.getAttribute("data-bg-opened") == "true") {
            var dAttrSave = this.popup.getAttribute("data-save");
            if (dAttrSave && !(itsoftApp.modules.cookie.getCookie(this.popup))) {
                this.popup.dispatchEvent(window.openEvent);
                DEBUG && console.log("data-bg open event");
            } else if (!dAttrSave) {
                this.popup.dispatchEvent(window.openEvent);
                DEBUG && console.log("data-bg else open event");
            } else {
                this.popup.dispatchEvent(window.closeEvent);
            }
        }

        if (!this.state.initedExemplar) {
            this.state.initedExemplar = true;
        }
    };
    // Перемещаем все всплывашки в конец <body>.
    // Это нужно для того, чтобы при открытии всплывашки,
    // событие "scroll" всплывало до <body> и <html>,
    // но НЕ всплывало до <div class="l-wrapper">.
    // Это важно, так как при открытии всплывашки прокрутка
    // убирается у <body> и появляется у <div class="l-wrapper">.
    // Тем самым, мы "отменяем скролл".
    //
    // NOTE: На самом деле, отменить стандартный скролл браузера нельзя
    // (иначе не было бы всей этой истории).
    // Можно отменить, например, всплытие события "click" или действие по умолчанию для него.
    // Но ряд событий отменить или прервать всплытие нельзя.

    /**
     * Изменение адресной строки браузера при открытии всплывашки
     * (по необходимости).
     * Доп. инфа:
     * http://stackoverflow.com/questions/824349/modify-the-url-without-reloading-the-page
     *
     * @param  {string} url     Новый адрес
     * @param  {string} popupID Необходимо для отработки случая, когда мы перешли на страницу по прямому адресу
     */
    Popup.prototype.changePageUrl = function (url) {
        // Если браузер не поддерживает работу с историей,
        // то прерываем выполнение функции.
        if (!window.history || typeof window.history.pushState !== "function" || typeof url !== "string") {
            DEBUG && console.log("%c[module popups] !window.history || typeof window.history.pushState != function || typeof url != string", "color: red");
            return;
        }

        // Переход "вперёд" по истории браузера ...
        if (url !== "back") {
            DEBUG && console.log("%c[module popups] trying to change page url to: " + url, "font-style: italic");
            window.history.pushState(false, false, url);
            this.globalState.historyPushed = true;

        // ... переход "назад"
        } else {
            // Случай, когда мы до этого открыли всплывашку и перешли "вперёд"
            if (this.globalState.historyPushed) {
                DEBUG && console.log("%c[module popups] trying to go back in history", "font-style: italic");
                window.history.back();

            // Случай, когда до этого не было перехода "вперёд"
            // (например, пользователь перешёл по прямой ссылке).
            } else if (typeof this.popupID === "string") {
                var urlToChange = staticBackUrl;
                urlToChange = staticBackUrl.substring(0, staticBackUrl.length - this.popupID.length - 1);
                DEBUG && console.log("%c[module popups] replacing page url to " + urlToChange, "font-style: italic; color: orange");
                window.history.replaceState(false, false, urlToChange);
            }
        }
    };

    Array.prototype.forEach.call(popups, function (popup) {
        new Popup(popup);
    });

    module.callback = {
        popup: Popup
    }
});